export const GET_DASHBOARD_URI_ACTION = 'GET_DASHBOARD_URI_ACTION';
export const GET_WORKSPACE_URI_ACTION = 'GET_WORKSPACE_URI_ACTION';
export const REGISTER_GOODDATA_EMBED_ACTION = 'REGISTER_GOODDATA_EMBED_ACTION';
export const SET_DASHBOARD_ID_ACTION = 'SET_DASHBOARD_ID_ACTION';
export const SET_WORKSPACE_URI_ACTION = 'SET_WORKSPACE_URI_ACTION';
export const SET_EMBED_STATUS_ACTION = 'SET_EMBED_STATUS_ACTION';
export const GET_KPI_DASHBOARDS_ACTION = 'GET_KPI_DASHBOARDS_ACTION';
export const SET_KPI_DASHBOARDS_ACTION = 'SET_KPI_DASHBOARDS_ACTION';
